/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import { ErrorMessage } from "formik";
import {
  TextInputComponent,
  SelectInputComponent,
  UploadImage,
  CountryCodeWithPhoneNumber,
} from "../../../../../common/components";
import {
  LEAD_STATUS_OPTIONS,
  LEAD_SOURCE_OPTIONS,
  RATING_OPTIONS,
  INTERESTED_PRODUCT_OPTIONS,
} from "../../../../../constants/leadDropdown";
import OwnerIcon from "../../../../../assets/icons/owner.svg";
import "./create-lead-primary-details.scss";
import { useLeadOwnerOptions } from "../../../../../utils/getLeadOwnerOptions";
import DatePickerComponent from "../../../../../common/components/date-picker/date-picker-compoenent";
import dayjs from "dayjs";

const CreateLeadPrimaryDetails = (props: any) => {
  const LEAD_OWNER_OPTIONS = useLeadOwnerOptions()
  return (
    <div className="">
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <div className="photo-container">
            <UploadImage
              label="Upload Photo"
              text="Photo"
              value={props?.values?.imageUrl}
              onChange={(file: any) => {
                props?.setFieldValue("imageUrl", file);
                props?.validateField("imageUrl");
                props?.setPreviewImage(true);
              }}
              onClick={() => {
                props?.setFieldTouched("imageUrl", true);
              }}
              showCloseButton
              handleClose={() => {
                props?.setFieldValue("imageUrl", null);
              }}
              isPreviewImage={props?.isPreviewImage}
            />
            <div>
              {props?.touched?.imageUrl && props?.errors?.imageUrl && (
                <div className="error-message">
                  {
                    <ErrorMessage
                      name={"imageUrl"}
                      component="div"
                      className="error-message"
                    />
                  }
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="text"
            fieldName="firstName"
            label="First Name"
            placeholder="Enter First Name"
            optional={true}
            disabled={false}
            value={props?.values.firstName}
            onChange={(e: any) =>
              props?.setFieldValue("firstName", e?.target?.value)
            }
            isRequired={true}
            isName={true}
            maxlength="50"
          />
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="text"
            fieldName="middleName"
            label="Middle Name "
            placeholder="Enter Middle Name"
            optional={false}
            disabled={false}
            value={props?.values.middleName}
            onChange={(e: any) =>
              props?.setFieldValue("middleName", e?.target?.value)
            }
            isRequired={false}
            isName={true}
            maxlength="50"
          />
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="text"
            fieldName="lastName"
            label="Last Name"
            placeholder="Enter Last Name"
            optional={true}
            disabled={false}
            value={props?.values.lastName}
            onChange={(e: any) =>
              props?.setFieldValue("lastName", e?.target?.value)
            }
            isRequired={true}
            isName={true}
            maxlength="50"
          />
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <SelectInputComponent
            fieldName="leadOwner"
            label="Lead Owner"
            options={LEAD_OWNER_OPTIONS}
            onChange={props?.setSelectedLeadOwner}
            value={props?.selectedLeadOwner}
            placeholder="Enter lead owner"
            icon={OwnerIcon}
          />
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <SelectInputComponent
            fieldName="leadSource"
            label="Lead Source"
            options={LEAD_SOURCE_OPTIONS}
            onChange={props?.setSelectedLeadSource}
            value={props?.selectedLeadSource || "None"}
          />
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="email"
            fieldName="email"
            label="Email"
            placeholder="Enter Email"
            optional={true}
            disabled={false}
            value={props?.values.email}
            onChange={(e: any) =>
              props?.setFieldValue("email", e?.target?.value)
            }
            isRequired={true}
          />
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <div className="form-group">
            <CountryCodeWithPhoneNumber
              fieldName="primaryPhoneNumber"
              label="Enter Primary Phone Number"
              placeholder={
                props?.values?.primaryPhoneNumber
                  ? ""
                  : "Enter Primary Phone Number"
              }
              onChange={(value: string, country: any, one: any, two: any) => {
                const countryCode = country?.dialCode;

                if (!countryCode) {
                  console.warn("Missing dialCode in country object");
                  return;
                }

                if (`+${countryCode}` == two) {
                  props?.setFieldValue("primaryPhoneNumber", null);
                } else {
                  if (two?.includes(`+${countryCode}`)) {
                    props?.setFieldValue("primaryPhoneNumber", two);
                  } else {
                    props?.setFieldValue("primaryPhoneNumber", countryCode);
                  }
                }
              }}
              onBlur={() => {
                props?.setFieldTouched("primaryPhoneNumber", true);
              }}
              value={props?.values?.primaryPhoneNumber || "+1"}
              onKeyDown={(value: any) => {
                if (value.location == 0 && value.key == "Backspace") {
                  props?.setFieldValue(
                    "primaryPhoneNumber",
                    props?.values?.primaryPhoneNumber?.substring(
                      0,
                      props?.values?.primaryPhoneNumber?.length
                    )
                  );
                }
                if (value.location == 0 && value.key == "Delete") {
                  props?.setFieldValue(
                    "primaryPhoneNumber",
                    props?.values?.primaryPhoneNumber?.substring(
                      0,
                      props?.values?.primaryPhoneNumber?.length
                    )
                  );
                }
              }}
              defaultCountry="us"
              optional={true}
              // countryCodeEditable
            />
            {props?.touched?.primaryPhoneNumber &&
              props?.touched?.primaryPhoneNumber && (
                <ErrorMessage
                  name={"primaryPhoneNumber"}
                  component="div"
                  className="error-message"
                />
              )}
          </div>
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <SelectInputComponent
            fieldName="leadStatus"
            label="Lead Status"
            options={LEAD_STATUS_OPTIONS}
            onChange={props?.setSelectedLeadStatus}
            value={props?.selectedLeadStatus || "None"}
          />
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <SelectInputComponent
            fieldName="rating"
            label="Confidence Score"
            options={RATING_OPTIONS}
            onChange={props?.setSelectedRating}
            value={props?.selectedRating} // This will bind the selected value
            placeholder="Select Confidence Score"
            colorProp={true}
            closeIcon
            onClear={() => props?.setSelectedRating("")}
          />
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <SelectInputComponent
            fieldName="interestedProduct"
            label="Interested Product"
            options={INTERESTED_PRODUCT_OPTIONS}
            onChange={props?.setInterestedProduct}
            value={props?.selectedInterestedProduct}
            placeholder=" Select Interested Product"
            multiple={true}
          />
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <DatePickerComponent
            label="Death Date"
            fieldName="deathDate"
            value={props?.deathDate || null}
            onChange={(date) => props?.setFieldValue("deathDate", date)}
            maxDate={dayjs().startOf("day")}
            optional={true}
            isLabel={true}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateLeadPrimaryDetails;
